import { Button, Dialog, styled, Typography } from '@mui/material';
import { useConfirmationModalStore } from '@stores/confirmationModalStore';

export const ConfirmationModal = () => {
  const { isOpen, handleClose, title, content, onOk } =
    useConfirmationModalStore();

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Container>
        <Header>
          <Typography variant="h5">{title || 'Discard changes?'}</Typography>
        </Header>
        <Content>
          <Typography variant="subtitle1">
            {content ||
              'You have unsaved changes. Are you sure you want to discard them?'}
          </Typography>
        </Content>
        <Footer>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color={'primary'} onClick={onOk}>
            Discard
          </Button>
        </Footer>
      </Container>
    </Dialog>
  );
};

const Footer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '16px',
  borderTop: `1px solid ${theme.palette.divider}`,
  gap: '8px',
}));

const Content = styled('div')(({ theme }) => ({
  padding: '16px',
  backgroundColor: theme.palette.background.default,
}));

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  height: '64px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
}));
